<template>
  <div id="app">
    <SWPTax :min="0" :max="100" :step="5" />
  </div>
</template>

<script>
import SWPTax from "./components/SWPTax.vue";

export default {
  name: "App",
  components: {
    SWPTax,
  },
};
</script>

<style>
#app {
}
</style>
